import { Button, Space, Input, Typography, message } from "antd";
import {
  SaveOutlined,
  ExportOutlined,
  LinkOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";

export default function ActionBar({
  designName,
  onDesignNameChange,
  onSave,
  onExport,
  onShare,
  saveLoading,
  disabledSave,
  showShare,
  shareUrl,
}) {
  const handleCopyShare = async () => {
    if (!shareUrl) return;
    try {
      await navigator.clipboard.writeText(shareUrl);
      message.success("Share link copied");
    } catch {
      message.error("Could not copy link");
    }
  };

  return (
    <div className="invitation-builder__action-bar">
      <Typography.Title level={4} style={{ margin: 0 }} className="invitation-builder__title">
        Invitation builder
      </Typography.Title>
      <Input
        placeholder="Design name"
        value={designName}
        onChange={(e) => onDesignNameChange(e.target.value)}
        style={{ maxWidth: 280 }}
      />
      <Space wrap>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          loading={saveLoading}
          disabled={disabledSave}
          onClick={onSave}
        >
          Save draft
        </Button>
        <Button icon={<ExportOutlined />} onClick={onExport}>
          Export
        </Button>
        {showShare ? (
          <Button
            icon={<ShareAltOutlined />}
            loading={saveLoading}
            onClick={onShare}
          >
            Share
          </Button>
        ) : null}
        {shareUrl ? (
          <Space.Compact style={{ maxWidth: 400 }}>
            <Input readOnly value={shareUrl} />
            <Button type="primary" icon={<LinkOutlined />} onClick={handleCopyShare}>
              Copy
            </Button>
          </Space.Compact>
        ) : null}
      </Space>
    </div>
  );
}
